export default "__VITE_ASSET__C85B2ggA__"